(function () {
  'use strict';

  function normalize(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  function initModal(modal) {
    if (modal.dataset.modalReady) return;
    modal.dataset.modalReady = 'true';
    var lastOpener = null;
    var closeButtons = modal.querySelectorAll('[data-case-close]');
    var question = modal.querySelector('[data-case-question]');

    function open(event) {
      if (event) lastOpener = event.currentTarget;
      modal.hidden = false;
      document.body.classList.add('case-id-modal-open');
      var close = modal.querySelector('.case-id-modal__close');
      if (close) window.setTimeout(function () { close.focus(); }, 30);
    }

    function close() {
      modal.hidden = true;
      document.body.classList.remove('case-id-modal-open');
      if (lastOpener) lastOpener.focus();
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-case-open], a[href="#case-id"], a[href="#case-id-quiz"], a[href="#quiz-case-id"], a[href="#abrir-case-id"]');
      if (!opener) return;

      event.preventDefault();
      open({ currentTarget: opener });
    });
    closeButtons.forEach(function (button) { button.addEventListener('click', close); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) close();
    });

    if (question && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var heading = question.querySelector('.case-id__model-heading');
        var choices = question.querySelector('.case-id__choices');
        if (!heading || !choices || choices.children.length < 10 || question.querySelector('.case-id-model-filter')) return;

        var search = document.createElement('input');
        search.type = 'search';
        search.className = 'case-id-model-filter';
        search.placeholder = 'Buscar modelo do celular';
        search.setAttribute('aria-label', 'Buscar modelo do celular');
        heading.insertAdjacentElement('afterend', search);
        search.addEventListener('input', function () {
          var term = normalize(search.value);
          choices.querySelectorAll('.case-id__choice').forEach(function (choice) {
            choice.hidden = term !== '' && normalize(choice.textContent).indexOf(term) === -1;
          });
        });
      }).observe(question, { childList: true, subtree: true });
    }
  }

  function init() {
    document.querySelectorAll('[data-case-modal]').forEach(initModal);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
